const STORAGE_KEY = 'scpiCifSimulationTunnel';

const productByType = {
    SCPIRendement: 'scpi',
    SCPIaCredit: 'scpi',
    SCPIDemembreeCIF: 'dismemberedScpi',
};

const entryPointByProduct = {
    scpi: 'overview',
    dismemberedScpi: 'products',
};

const getStorage = () => {
    if ('undefined' === typeof window || !window.sessionStorage) {
        return null;
    }

    return window.sessionStorage;
};

const getCurrentSimulationRoute = () => {
    if ('undefined' === typeof window) {
        return null;
    }

    const match = window.location.pathname.match(/^\/rip\/([^/]+)\/simulations\/([^/]+)\/([^/]+)/);

    if (!match) {
        return null;
    }

    const [, ripId, simulationId, step] = match;

    return { ripId, simulationId, step };
};

export const getScpiSimulationProduct = ({ type }) => productByType[type];

export const getScpiSimulationEntryPoint = (product) => entryPointByProduct[product];

export const startSimulationTunnel = ({ recommendationUrl, simulationId, entryPoint, recommendationType }) => {
    const storage = getStorage();

    if (!storage) {
        return;
    }

    storage.setItem(STORAGE_KEY, JSON.stringify({
        recommendationUrl,
        simulationId,
        entryPoint,
        recommendationType,
    }));
};

export const clearSimulationTunnel = () => {
    const storage = getStorage();

    if (storage) {
        storage.removeItem(STORAGE_KEY);
    }
};

export const getSimulationTunnel = () => {
    const storage = getStorage();

    if (!storage) {
        return null;
    }

    const rawTunnel = storage.getItem(STORAGE_KEY);

    if (!rawTunnel) {
        return null;
    }

    try {
        const simulationTunnel = JSON.parse(rawTunnel);
        const route = getCurrentSimulationRoute();

        if (!route || route.simulationId !== simulationTunnel.simulationId) {
            return null;
        }

        return {
            ...simulationTunnel,
            currentStep: route.step,
            isFirstPage: route.step === simulationTunnel.entryPoint,
            isLastPage: 'simulation' === route.step,
            recommendationUrl: simulationTunnel.recommendationUrl,
        };
    } catch (error) {
        clearSimulationTunnel();

        return null;
    }
};
